<template>
  <div>
    <div id="player"></div> 
  </div>
</template>

<script>
export default {
  props: ["media", "enroll_id", "user_id", "subject_id", "lesson_id", "access_token", "lesson_status"],
  data() {
    return {
      player: null,
      videoDuration: 0,
      progress: 0,
      intervalId: null,
      playSeconds: 0,
      maxReached: 0,
      protectSeekInterval: null,
      playTimer: null,
    };
  },

  async mounted() {
    if (!window.YT || !window.YT.Player) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);

      window.onYouTubeIframeAPIReady = () => {
        this.loadPlayer();
      };
    } else {
      this.loadPlayer();
    }
  },

  methods: {
    loadPlayer() {
      this.player = new window.YT.Player("player", {
        height: "624",
        width: "100%",
        videoId: this.media.youtube_id,
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
      });
    },

    onPlayerReady() {
      this.videoDuration = Math.floor(this.player.getDuration()) - 1; 

     // มีการดูจนจบไปแล้ว เลยให้กอได้
       if (this.lesson_status != 1) {
      this.protectSeekInterval = setInterval(() => {
        const currentTime = this.player.getCurrentTime(); 
        if (this.player.getPlayerState() === window.YT.PlayerState.PLAYING) {
          if (currentTime > this.maxReached + 1) {
            this.player.seekTo(this.maxReached); // 🔒 ห้ามข้ามไปเกินที่ดู
          }
        }
      }, 1000);
        
       }
    },


    updateProgress() {  

      // มีการดูจนจบไปแล้ว
      if (this.lesson_status != 1) {
        const model = {
        user_id: this.user_id,
        subject_id: this.subject_id,
        lesson_id: this.lesson_id,
        lesson_time_sec: this.playSeconds,
        duration: this.videoDuration,
        enroll_id: this.enroll_id,
      };

      this.$store
        .dispatch("Lessons/saveLessonYouTubeProgress", {
          model,
          accessToken: this.access_token,
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("Auth/logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
      }
     
    },

    onPlayerStateChange(event) {
      if (event.data === window.YT.PlayerState.PLAYING) {
        if (!this.playTimer) {
          this.playTimer = setInterval(() => {
            this.playSeconds++;
            this.maxReached = this.playSeconds;

            // ทุก 10 วิ อัพเดตความคืบหน้า
            if (this.playSeconds % 10 === 0) {
              this.updateProgress();
            }
          }, 1000);
        }
      }

      if (event.data === window.YT.PlayerState.PAUSED) {
        this.updateProgress(); 
        clearInterval(this.playTimer);
        this.playTimer = null;
      }

      if (event.data === window.YT.PlayerState.ENDED) {
        clearInterval(this.playTimer);
        this.playTimer = null; 
        this.updateProgress(); 
      }
    },
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
    clearInterval(this.playTimer);
    clearInterval(this.protectSeekInterval);
  },
};
</script>
